<script>
import 'vue-select/dist/vue-select.css'
import USER_MAIL_CONFIG from '@/gql/queries/userMailConfig.graphql';
import SAVE_DRAFT_MAIL from '@/gql/mutations/saveDraftMail.graphql';
import {gqlQuery, gqlMutation} from '@/gqlClient.js';
import settings from "@/settings"
import Ckeditor from "@/components/ui/Ckeditor.vue";

export default {
  name: 'WebmailCompose',
  components: {Ckeditor},
  props: {
    date: {type: String, default: ''},
    to_original: {type: String, default: ''},
    cc_original: {type: String, default: ''},
    bcc_original: {type: String, default: ''},
    to_answer: {type: [String, Array], default: () => []},
    subject: {type: String, default: ''},
    bodyFrom: {type: String, default: ''},
    bodyHtmlFrom: {type: String, default: ''},
    assistantset: {type: Array, default: () => []},
  },
  data() {
    return {
      draftUuid: null,
      attachments: [], // File[]
      to: Array.isArray(this.to_answer) ? this.to_answer : (this.to_answer ? this.to_answer.split(',') : []),
      cc: Array.isArray(this.cc_original) ? this.cc_original : (this.cc_original ? this.cc_original.split(',') : []),
      bcc: Array.isArray(this.bcc_original) ? this.bcc_original : (this.bcc_original ? this.bcc_original.split(',') : []),
      subjectField: typeof this.subject === 'string' ? this.subject : '',
      body: '',
      context: '',
      signatures: [],
      generated: false,
      btnLabel: 'Réponse IA',
      showCc: false,
      showBcc: false,
      showContext: false,
      isDraft: false,
      toInput: '',
      ccInput: '',
      bccInput: '',
    }
  },
  computed: {
    uuid() {
      return this.$route.params.id
    },
  },
  async mounted() {
    gqlQuery(USER_MAIL_CONFIG, {uuid: this.uuid}).then(response => {
      this.signatures = response.body.data.user_mail_config.signatures
    })
    if (this.assistantset.length <= 0) {
      const estabRes = await gqlQuery(ESTABLISHMENT_SET, {consultant_uid: this.$store.state.profile.data.uid});
      const establishmentUids = (estabRes.body.data.establishment_set || []).map(e => e.uid);
      if (establishmentUids.length > 0) {
        const results = await Promise.all(
            establishmentUids.map(uid => gqlQuery(ASSISTANT, {
              tags: ["mail"],
              establishment_id: uid,
              bool_compute_elos: false
            }))
        );
        const seen = new Set();
        this.assistantset = results
            .flatMap(r => r.body.data.assistants || [])
            .filter(a => a.is_active && !seen.has(a.uid) && seen.add(a.uid));
      }
    }
    if (this.draftUuid) return;

    // ✅ Initialisation du body
    if (!this.body && (this.bodyHtmlFrom || this.bodyFrom)) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(this.bodyHtmlFrom, "text/html")
      const bodyContent = doc.body ? doc.body.innerHTML : this.bodyHtmlFrom
      this.body = `
        <p>--------</p>
        <p><b>De:</b> ${this.to}</p>
        ${this.cc_original ? `<p><b>CC:</b> ${this.cc_original}</p>` : ''}
        ${this.bcc_original ? `<p><b>CCI:</b> ${this.bcc_original}</p>` : ''}
        <p><b>A:</b> ${this.to_original}</p>
        <p><b>Date:</b> ${this.date}</p>
        <br>
        ${bodyContent}
      `
    } else if (this.bodyFrom) {
      this.body = `
        <p>--------</p>
        <p><b>De:</b> ${this.to}</p>
        ${this.cc_original ? `<p><b>CC:</b> ${this.cc_original}</p>` : ''}
        ${this.bcc_original ? `<p><b>CCI:</b> ${this.bcc_original}</p>` : ''}
        <p><b>A:</b> ${this.to_original}</p>
        <p><b>Date:</b> ${this.date}</p>
        <pre>${this.bodyFrom}</pre>
      `
    }
    if (this.cc.length > 0) this.showCc = true
    if (this.bcc.length > 0) this.showBcc = true

  },
  watch: {
    uuid() {
      return this.$route.params.id
    },
    body() {
      this.$emit("dirty");
    },
    to() {
      this.$emit("dirty");
    },
    cc() {
      this.$emit("dirty");
    },
    bcc() {
      this.$emit("dirty");
    },
    subjectField() {
      this.$emit("dirty");
    }
  },
  methods: {
    pushPendingTag(field, value) {
      const trimmed = (value || '').trim();
      if (trimmed && !this[field].includes(trimmed)) {
        this[field] = [...this[field], trimmed];
      }
      this[field + 'Input'] = '';
    },
    loadDraft(draft) {
      this.isDraft = true;
      // UID IMAP du brouillon (pour mise à jour lors de la sauvegarde)
      this.draftUuid = draft.uid || draft.uuid || null;

      this.to = draft.to
          ? draft.to.split(',').map(v => v.trim()).filter(Boolean)
          : [];

      this.cc = draft.cc
          ? draft.cc.split(',').map(v => v.trim()).filter(Boolean)
          : [];

      this.bcc = draft.bcc
          ? draft.bcc.split(',').map(v => v.trim()).filter(Boolean)
          : [];

      this.subjectField = draft.subject || '';

      if (draft.body_html && draft.body_html.trim()) {
        this.body = draft.body_html;
      } else if (draft.body_text && draft.body_text.trim()) {
        this.body = `<pre>${draft.body_text}</pre>`;
      } else {
        this.body = '';
      }

      this.showCc = this.cc.length > 0;
      this.showBcc = this.bcc.length > 0;

      this.$emit("clean");
    },
    handleFiles(event) {
      const files = Array.from(event.target.files)
      for (const file of files) {
        this.attachments.push(file)
      }
      console.log(this.attachments)

      event.target.value = ''
    },
    async generateAnwser(uid) {
      this.generated = true
      this.btnLabel = 'Génération en cours...'
      const body = {
        assistant_id: uid,
        user_mail_config_id: this.uuid,
        additional_info: this.context.trim() || undefined,
        email_context: {
          subject: this.subjectField,
          to: Array.isArray(this.to) ? this.to.join(',') : this.to,
          to_original: this.to_original,
          date: this.date,
          body: this.bodyFrom || this.body.replace(/<[^>]+>/g, ''),
          body_html: this.bodyHtmlFrom || this.body,
        },
      }
      this.$http.post(
          settings.backendUrl + "/admin/webmail/generate_email_answer",
          JSON.stringify(body),
          {headers: {'Content-Type': 'application/json'}}
      ).then((response) => {
        if (response.body.steps_simulations) {
          // get last steps_simulations
          const lastIndex = response.body.steps_simulations.length - 1
          const answerHtml = response.body.steps_simulations[lastIndex].answer
          this.body = answerHtml + "<br><br>" + this.body
        }
        this.$store.dispatch("notify", {
          level: "success",
          text: "Réponse IA générée avec succès !",
          seconds: 5
        })
        this.generated = false
        this.btnLabel = 'Réponse IA'
      }).catch(response => {
        this.$store.dispatch("notify", {
          level: "danger",
          text: "Erreur lors de la génération de la réponse IA:" + response.body.error.message,
          seconds: 5
        });
        this.generated = false
        this.btnLabel = 'Réponse IA'
      })
    },
    async saveDraft() {
      const payload = {
        config_id: this.uuid,
        subject: this.subjectField,
        to: this.to.join(","),
        cc: this.cc.join(","),
        bcc: this.bcc.join(","),
        body_text: this.body.replace(/<[^>]+>/g, ""),
        body_html: this.body,
        attachments: JSON.stringify(this.attachments),
      };
      if (this.draftUuid) {
        payload.uid = this.draftUuid;
      }

      const res = await gqlMutation(SAVE_DRAFT_MAIL, payload);
      const saved = res.body.data.save_draft_mail;

      // Le backend ne retourne pas le nouvel UID IMAP : on réinitialise
      // pour qu'une prochaine sauvegarde crée un nouveau message plutôt
      // que de tenter de supprimer un UID devenu invalide.
      this.draftUuid = null;

      this.$emit("clean");
      return saved;
    },
    async sendMail() {
      const btn = this.$refs.send_btn
      btn.disabled = true
      btn.innerText = 'Envoi en cours...'

      try {
        const formData = new FormData()

        formData.append("config_id", this.uuid)
        formData.append("to", this.to.join(','))
        formData.append("cc", this.cc.join(','))
        formData.append("bcc", this.bcc.join(','))
        formData.append("subject", this.subjectField)

        const bodyText = this.body.replace(/<[^>]+>/g, '')
        formData.append("body", bodyText)
        formData.append("html", this.body)

        for (const file of this.attachments) {
          formData.append("attachments", file)
        }

        const res = await this.$http.post(
            settings.backendUrl + "/admin/webmail/send_mail",
            formData,
            {headers: {"Content-Type": "multipart/form-data"}}
        )

        if (res.body.ok) {
          this.$store.dispatch("notify", {
            level: "success",
            text: "E-mail envoyé avec succès !",
            seconds: 2
          })
          this.$emit("sent")
        } else {
          throw new Error(res.body.error)
        }

      } catch (e) {
        this.$store.dispatch("notify", {
          level: "danger",
          text: "Erreur lors de l'envoi de l'e-mail: <br>" + e.body.error,
          seconds: 10
        })
        btn.disabled = false
        btn.innerText = 'Envoyer'
      }
    },
    addSignature(signature) {
      //check the first De: occurrence and insert before that
      const deIndex = this.body.indexOf('--------')
      if (deIndex !== -1) {
        this.body = this.body.slice(0, deIndex) +
            `<p>${signature.html}</p><br>` +
            this.body.slice(deIndex)
      } else {
        this.body += `<br><p>${signature.html}</p>`
      }
    },
    deleteDraft() {
      if (!confirm("Voulez-vous vraiment supprimer ce brouillon ?")) return;
      this.$emit("draft-deleted", this.draftUuid);
    }
  }
}
</script>

<template>
  <div class="compose-root">

    <!-- HEADERS -->
    <div class="compose-headers px-3">

      <!-- TO -->
      <div class="header-line align-items-center">

        <!-- ACTIONS -->
        <div class="me-2 flex-shrink-0">
          <div class="btn-group">

            <!-- ENVOYER -->
            <button
                ref="send_btn"
                class="btn btn-primary btn-sm"
                @click.prevent="sendMail"
            >
              Envoyer
            </button>

            <!-- IA -->
            <div class="btn-group" v-if="assistantset.length > 0">
              <button
                  class="btn btn-outline-success btn-sm dropdown-toggle"
                  data-bs-toggle="dropdown"
                  :disabled="generated"
              >
                {{ btnLabel }}
              </button>

              <div class="dropdown-menu">
                <a
                    v-for="assistant in assistantset"
                    :key="assistant.uid"
                    class="dropdown-item"
                    @click.prevent="generateAnwser(assistant.uid)"
                >
                  {{ assistant.name }}
                </a>
              </div>
            </div>
            <!-- PJ -->
            <label class="btn btn-outline-primary btn-sm mb-0">
              <i class="fas fa-paperclip"></i>
              <input
                  type="file"
                  multiple
                  hidden
                  @change="handleFiles"
              />
            </label>
            <!-- SIGNATURES -->
            <div class="btn-group"
                 v-if="signatures.length > 0"
            >
              <button
                  class="btn btn-outline-primary btn-sm dropdown-toggle"
                  data-bs-toggle="dropdown"
              >
                Signature
              </button>

              <div class="dropdown-menu">
                <a
                    v-for="signature in signatures"
                    :key="signature.uuid"
                    class="dropdown-item"
                    @click.prevent="addSignature(signature)"
                >
                  {{ signature.name }}
                </a>
              </div>
            </div>
            <!-- ACTIONS DRAFT -->

            <button v-if="isDraft"
                    class="btn btn-danger btn-sm btn-icon-only"
                    @click="deleteDraft"
            >
              <i class="fa-solid fa-trash me-2"></i>
            </button>

          </div>
        </div>

        <!-- V-SELECT -->
        <div class="flex-fill position-relative">
          <v-select
              v-model="to"
              multiple
              taggable
              :options="[]"
              class="w-100"
              placeholder="Ajouter des destinataires"
              @search="toInput = $event"
              @search:blur="pushPendingTag('to', toInput)"
          />
        </div>

        <div class="cc-actions small">
          <a v-if="!showCc" @click.prevent="showCc = true">Cc</a>
          <a v-if="!showBcc" @click.prevent="showBcc = true">Cci</a>
        </div>
      </div>

      <!-- CC -->
      <div v-if="showCc" class="header-line">
        <span class="label">Cc</span>
        <v-select
            v-model="cc"
            multiple
            taggable
            :options="[]"
            class="flex-fill"
            @search="ccInput = $event"
            @search:blur="pushPendingTag('cc', ccInput)"
        />
      </div>

      <!-- CCI -->
      <div v-if="showBcc" class="header-line">
        <span class="label">Cci</span>
        <v-select
            v-model="bcc"
            multiple
            taggable
            :options="[]"
            class="flex-fill"
            @search="bccInput = $event"
            @search:blur="pushPendingTag('bcc', bccInput)"
        />
      </div>

      <!-- SUBJECT -->
      <div class="header-line">
        <span class="label">Objet</span>
        <input
            type="text"
            class="form-control border-0 shadow-none"
            v-model="subjectField"
            placeholder="Objet"
        />
      </div>

      <!-- CONTEXTE IA -->
      <div class="header-line ai-context-toggle" @click="showContext = !showContext">
        <span class="label text-muted small">Contexte IA</span>
        <span class="small text-muted flex-fill" v-if="!showContext && !context">Ajouter un contexte pour la génération automatique...</span>
        <span class="small text-success flex-fill" v-else-if="!showContext && context">{{ context }}</span>
        <i class="small text-muted" :class="showContext ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
      </div>
      <div v-if="showContext" class="ai-context-field px-1 py-2">
        <textarea
            v-model="context"
            class="form-control border-0 shadow-none"
            rows="3"
            placeholder="Décrivez le contexte, les instructions ou les informations supplémentaires pour guider la génération IA..."
            @click.stop
        />
      </div>

      <div class="attachments mx-2 my-2" v-if="attachments.length">
        <div
            class="attachment"
            v-for="file in attachments"
            :key="file.id"
        >
          <i class="fas fa-file"/>
          <div class="meta">
            <span class="name">{{ file.name }}</span>
          </div>
        </div>
      </div>


    </div>

    <!-- EDITOR -->
    <div class="compose-editor px-3">
      <Ckeditor v-model="body"/>
    </div>

  </div>
</template>

<style scoped lang="scss">
.compose-container {
  padding: 8px 16px;
}

.form-zone {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.compact-line {
  margin-top: -4px;
}

label {
  width: 60px;
  font-weight: 500;
  color: #555;
  margin: 0;
}

.form-line a {
  color: #6c757d;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.compose-root {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.compose-topbar {
  z-index: 5;
}

.compose-headers {
  border-bottom: 1px solid #e0e0e0;
}

.header-line {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.header-line:last-child {
  border-bottom: none;
}

.label {
  width: 50px;
  font-size: 0.85rem;
  color: #666;
}

.cc-actions a {
  cursor: pointer;
  color: #6c757d;
  margin-left: 6px;
}

.cc-actions a:hover {
  text-decoration: underline;
}

.compose-editor {
  flex: 1;
  overflow: hidden;
}

.ai-context-toggle {
  cursor: pointer;
  user-select: none;

  &:hover {
    background: #f8f9fa;
  }
}

.ai-context-field textarea {
  resize: vertical;
  font-size: 0.875rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.attachments {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.attachment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  background: #f4f6f8;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  max-width: 220px;
}

.attachment:hover {
  background: #e9edf2;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 20px;
}

.meta {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.name {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.size {
  font-size: 11px;
  color: #777;
}

</style>
